const single_sign_on = {
    forbidden_domains: 'Public email domains are not allowed.',
    duplicated_domains: 'There are duplicate domains.',
    invalid_domain_format: 'Invalid domain format.',
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
